import { IHand } from 'models'
import { theme } from 'global/styles/theme'
import { THEME_ANIMAL_COLORS, ANIMAL_COLOR_TO_UI_THEME } from 'global/constants'

export const animalColor = (color: IHand['color'] | undefined): string => {
  return color ? theme.colors[THEME_ANIMAL_COLORS[color]] || 'white' : 'white'
}

export const animalColorTheme = (color: IHand['color']) => {
  return THEME_ANIMAL_COLORS[color]
}

export const animalColorUiTheme = (color: IHand['color']) => {
  return ANIMAL_COLOR_TO_UI_THEME[color]
}
